import React, { ReactNode } from 'react';
import { NavMetricPublisher } from 'src/commons/utils/metrics';
import { logger } from 'src/commons/utils/logger';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { CHOOSE_ACCOUNT_PATH } from 'src/commons/constants';

interface Props {
  children: ReactNode;
}

interface InnerProps {
  destination: string;
  children: ReactNode;
}

class InterstitialErrorBoundaryInner extends React.Component<
  InnerProps,
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    NavMetricPublisher.publishCounterMonitor('interstitial_modal_error', 1);
    logger.error(
      '[InterstitialModal] Error caught, redirecting to /choose-account',
      error,
    );

    if (this.props.destination?.includes(CHOOSE_ACCOUNT_PATH)) {
      window.location.href = this.props.destination;
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export const InterstitialErrorBoundary: React.FC<Props> = ({ children }) => {
  const { interstitialDestinationUrl } = useConsolidatedNavContext();

  return (
    <InterstitialErrorBoundaryInner destination={interstitialDestinationUrl}>
      {children}
    </InterstitialErrorBoundaryInner>
  );
};
